export const DEFAULT_FULFILLMENT_TYPE = "Delivery";
